export class TravelStatus {
	public id: number;
	public name: string;
	public prefix: string;
	
	constructor(server_obj: any) {
		this.prefix = 'tst_';
		if (server_obj) {
			this.id         = Number(server_obj[this.prefix + 'id']);
			this.name     	= server_obj[this.prefix + 'name'];
		} /* else {

	} */
	}
}
